/*
 * File: misc.js
 *
 * Desc: js for misc scripts in the theme
 *
 */
(function(Drupal) {
  Drupal.behaviors.krakenMisc = {
    attach(context, settings) {
      // Add functionality for jump menu on /law-history-project/my-graduaing-class
      const sel = document.getElementById('edit-field-profile-graduating-class-target-id-verf');
      if (sel) {
        sel.addEventListener('change', () => {
            if (sel.value == 'All') {
              return;
            }
            window.location.replace(`/node/${sel.value}`);
        })
      }
    }
  };
})(Drupal);
